import { Record } from 'immutable';
import remove from 'lodash/fp/remove';
import * as types from './actionTypes';
import constants from '../constants';

const requestReducerState = Record({
  feeds: [],
  feed: {
    id: null,
  },
  [constants.ERROR_KEY]: null,
  [constants.SUCCESS_KEY]: null,
  [constants.FETCHING_KEY]: false,
});

export default (state = requestReducerState(), action) => {
  const { type, payload } = action;
  switch (type) {
    case types.FEEDS_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('feeds', payload);
    case types.FEED_SUCCESS:
    case types.CREATE_FEED_SUCCESS:
    case types.UPDATE_FEED_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.SUCCESS_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('feed', payload);
    case types.DELETE_FEED_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.SUCCESS_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('feeds', remove({ id: payload })(state.feeds));
    case types.FEEDS_REQUEST:
    case types.FEED_REQUEST:
    case types.CREATE_FEED_REQUEST:
    case types.UPDATE_FEED_REQUEST:
    case types.DELETE_FEED_REQUEST:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.SUCCESS_KEY, null)
        .set(constants.FETCHING_KEY, true);
    case types.FEEDS_FAILURE:
    case types.FEED_FAILURE:
    case types.CREATE_FEED_FAILURE:
    case types.UPDATE_FEED_FAILURE:
    case types.DELETE_FEED_FAILURE:
      return state
        .set(constants.FETCHING_KEY, false)
        .set(constants.SUCCESS_KEY, null)
        .set(constants.ERROR_KEY, action.payload);
    case types.RESET_FEED:
      return state.set('feed', requestReducerState().feed);
    default:
      return state;
  }
};
